import React from 'react';
import Link from 'next/link';
import { ChevronRight, Home } from 'lucide-react';

export default function Breadcrumb() {
  return (
    <nav className="flex items-center gap-1.5 mb-6 text-sm" aria-label="Breadcrumb">
      <Link
        href="/"
        className="flex items-center gap-1 transition-colors duration-150"
        style={{ color: 'var(--muted-foreground)' }}
      >
        <Home size={13} />
        Home
      </Link>
      <ChevronRight size={13} style={{ color: 'var(--muted-foreground)' }} />
      <span style={{ color: 'var(--foreground)' }}>Submit Contribution</span>
    </nav>
  );
}